import React, { useEffect } from 'react';

import Img from 'gatsby-image';
import iconArrow from '../assets/images/photos/our-offices/arrow.png';
import mapUae from '../assets/images/photos/our-offices/map-uae.png';
import mapItaly from '../assets/images/photos/our-offices/map-it.png';
import mapFrancePolynesia from '../assets/images/photos/our-offices/map-fr.png';
import mapIreland from '../assets/images/photos/our-offices/map-ireland.png';
import mapCostaRica from '../assets/images/photos/our-offices/map-costa-rica.png';
import mapUsa from '../assets/images/photos/our-offices/map-usa.png';
import close from '../assets/images/photos/our-offices/close.svg';
import { isClient } from '../helpers';

const addressType = {
  // usa: 'usa',
  // costaRica: 'costaRica',
  // ireland: 'ireland',
  italy: 'italy',
  uae: 'uae',
  // frenchPolynesia: 'frenchPolynesia',
};

const pcConfig = [
  // {
  //   type: addressType.usa,
  //   top: 209,
  //   left: 288,
  //   width: 27,
  // },
  // {
  //   type: addressType.costaRica,
  //   top: 316,
  //   left: 262,
  //   width: 27,
  // },
  // {
  //   type: addressType.ireland,
  //   top: 155,
  //   left: 514,
  //   width: 27,
  // },
  {
    type: addressType.italy,
    top: 188,
    left: 576,
    width: 27,
  },
  {
    type: addressType.uae,
    top: 255,
    left: 709,
    width: 41,
  },
  // {
  //   type: addressType.frenchPolynesia,
  //   top: 380,
  //   left: 1156,
  //   width: 27,
  // },
];

const laptopConfig = [
  // {
  //   type: addressType.usa,
  //   top: 134,
  //   left: 243,
  //   width: 23,
  // },
  // {
  //   type: addressType.costaRica,
  //   top: 223,
  //   left: 220,
  //   width: 23,
  // },
  // {
  //   type: addressType.ireland,
  //   top: 89,
  //   left: 428,
  //   width: 23,
  // },
  {
    type: addressType.italy,
    top: 116,
    left: 479,
    width: 23,
  },
  {
    type: addressType.uae,
    top: 171,
    left: 590,
    width: 35,
  },
  // {
  //   type: addressType.frenchPolynesia,
  //   top: 277,
  //   left: 960,
  //   width: 23,
  // },
];

const tabletConfig = [
  // {
  //   type: addressType.usa,
  //   top: 108,
  //   left: 193,
  //   width: 19,
  //   popup: 10,
  // },
  // {
  //   type: addressType.costaRica,
  //   top: 179,
  //   left: 176,
  //   width: 19,
  //   popup: 10,
  // },
  // {
  //   type: addressType.ireland,
  //   top: 72,
  //   left: 342,
  //   width: 19,
  // },
  {
    type: addressType.italy,
    top: 92,
    left: 383,
    width: 19,
  },
  {
    type: addressType.uae,
    top: 138,
    left: 473,
    width: 25,
  },
  // {
  //   type: addressType.frenchPolynesia,
  //   top: 221,
  //   left: 769,
  //   width: 19,
  //   popup: 480,
  // },
];

const mobileConfig = [
  // {
  //   type: addressType.usa,
  //   top: 85,
  //   left: 133,
  //   width: 19,
  //   popup: 140,
  // },
  // {
  //   type: addressType.costaRica,
  //   top: 128,
  //   left: 119,
  //   width: 19,
  //   popup: 137,
  // },
  // {
  //   type: addressType.ireland,
  //   top: 60,
  //   left: 230,
  //   width: 19,
  //   popup: 10,
  // },
  {
    type: addressType.italy,
    top: 75,
    left: 260,
    width: 19,
    popup: 10,
  },
  {
    type: addressType.uae,
    top: 107,
    left: 322,
    width: 22,
    popup: 40,
  },
  // {
  //   type: addressType.frenchPolynesia,
  //   top: 161,
  //   left: 527,
  //   width: 19,
  //   popup: 240,
  // },
];

const smMobileConfig = [
  // {
  //   type: addressType.usa,
  //   top: 50,
  //   left: 93,
  //   width: 19,
  //   popup: 100,
  // },
  // {
  //   type: addressType.costaRica,
  //   top: 80,
  //   left: 85,
  //   width: 19,
  //   popup: 100,
  // },
  // {
  //   type: addressType.ireland,
  //   top: 30,
  //   left: 166,
  //   width: 19,
  //   popup: 10,
  // },
  {
    type: addressType.italy,
    top: 40,
    left: 185,
    width: 19,
    popup: 10,
  },
  {
    type: addressType.uae,
    top: 65,
    left: 232,
    width: 22,
    popup: 40,
  },
  // {
  //   type: addressType.frenchPolynesia,
  //   top: 105,
  //   left: 380,
  //   width: 19,
  //   popup: 100,
  // },
];

const markerAddressImage = {
  // usa: mapUsa,
  uae: mapUae,
  italy: mapItaly,
  // ireland: mapIreland,
  // costaRica: mapCostaRica,
  // frenchPolynesia: mapFrancePolynesia,
};

const ImageMap = ({ map }) => {
  if (!isClient) {
    return null;
  }
  const mapImage = document.getElementsByClassName('office-map');

  const useWindowSize = () => {
    const [size, setSize] = React.useState([0, 0]);
    React.useLayoutEffect(() => {
      const updateSize = () => {
        setSize([window.innerWidth, window.innerHeight]);
      };
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);

    return size;
  };

  function useForceUpdate() {
    const [value, setValue] = React.useState(0);
    return () => setValue((v) => v + 1); // update the state to force render
  }

  const showWindowDimensions = () => {
    const [width] = useWindowSize();
    useForceUpdate();
    return width;
  };

  const getMarkerConfig = () => {
    const width = showWindowDimensions();
    const laptop = 1279.98;
    const tablet = 1023.98;
    const mobile = 767.98;
    const smMobile = 575.98;
    const xsMobile = 374.98;

    if (width >= laptop) {
      return pcConfig;
    }

    if (width < laptop && width >= tablet) {
      return laptopConfig;
    }

    if (width < tablet && width >= mobile) {
      return tabletConfig;
    }

    if (width < mobile && width >= smMobile) {
      return mobileConfig;
    }

    if (width < smMobile && width >= xsMobile) {
      return smMobileConfig;
    }

    return smMobileConfig;
  };

  const markerConfig = getMarkerConfig();

  const redirectToYoutube = () => {
    const href = 'https://www.youtube.com/watch?v=6lsO343qA2M';

    Object.assign(document.createElement('a'), {
      target: '_blank',
      href,
    }).click();
  };

  const hideAllMarkers = () => {
    const marker = document.getElementsByClassName('marker');
    if (marker.length) {
      for (let i = 0; i < marker.length; i += 1) {
        marker[i].remove();
      }
    }
  };

  const showMarkerInfo = (markerInfo) => {
    const isUae = markerInfo.type === addressType.uae;
    const imageSrc = markerAddressImage[markerInfo.type];
    const img = document.createElement('img');
    img.src = imageSrc;
    const closeImg = document.createElement('img');
    closeImg.src = close;
    closeImg.className = 'close';
    closeImg.addEventListener('click', hideAllMarkers);

    const markerNode = document.createElement('DIV');

    markerNode.classList.add('marker');
    markerNode.classList.add(`marker-${markerInfo.type}`);
    markerNode.appendChild(img);
    markerNode.appendChild(closeImg);
    markerNode.style.top = `${markerInfo.top + 15}px`;
    markerNode.style.left = `${markerInfo.popup || markerInfo.left - 250}px`;

    if (isUae) {
      const tour = document.createElement('DIV');
      tour.classList.add('tour');

      const tourText = document.createElement('DIV');
      tourText.innerText = 'Take a tour';
      tour.classList.add('tour-text');

      const tourLink = document.createElement('img');
      tourLink.src = iconArrow;
      tourLink.className = 'tour-link';
      tourLink.addEventListener('click', redirectToYoutube);

      tour.appendChild(tourText);
      tour.appendChild(tourLink);
      markerNode.appendChild(tour);
    }

    mapImage[0].appendChild(markerNode);
  };

  useEffect(() => {
    if (mapImage.length) {
      markerConfig.map((con) => {
        const markerWithType = document.getElementsByClassName(`marker-${con.type}`);
        const hoverDivContainer = document.getElementsByClassName('hover-div-container');

        const mapHoverArea = document.createElement('DIV');

        if (hoverDivContainer.length < markerConfig.length) {
          mapHoverArea.classList.add('hover-div-container');
        }

        mapHoverArea.style.width = `${con.width}px`;
        mapHoverArea.style.height = `${con.width}px`;
        // mapHoverArea.style.backgroundColor = '#929191';
        mapHoverArea.style.borderRadius = '50%';
        mapHoverArea.style.top = `${con.top}px`;
        mapHoverArea.style.left = `${con.left}px`;
        mapHoverArea.onmouseover = () => {
          hideAllMarkers();

          if (!markerWithType.length) {
            showMarkerInfo(con);
          }
        };
        mapImage[0].appendChild(mapHoverArea);

        return null;
      });
    }
  });

  return (
    <Img
      key={`${showWindowDimensions()}`}
      className="office-map"
      fluid={map}
      style={{ overflow: 'none' }}
    />
  );
};

export default ImageMap;
